import randomString from '@/utils/random-string';

interface IconStarGradientProps {
  /** id must be unique for each instance */
  id?: string;
  size?: number;
  from?: string;
  to?: string;
}
const IconStarGradient = ({ id: _id, size = 22, from = '#5AE4FF', to = '#A7FF7B' }: IconStarGradientProps) => {
  const id = _id || `icon-star-gradient-${randomString(6)}`;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 16 16" fill="none">
      <path
        d="M3.98973 9.93405L3.45345 13.2534C3.38035 13.7073 3.55902 14.1646 3.91552 14.4354C4.27257 14.7056 4.74669 14.7418 5.13679 14.5288L8.00052 12.9709L10.8642 14.5291C11.0337 14.6207 11.2193 14.6668 11.403 14.6668C11.6436 14.6668 11.8836 14.5883 12.0861 14.4357C12.4428 14.1649 12.6221 13.7076 12.5484 13.2537L12.0127 9.93434L14.3186 7.57714C14.6339 7.25524 14.7462 6.77487 14.6109 6.33769C14.4751 5.90081 14.1116 5.58095 13.6753 5.51382L10.48 5.02003L9.04088 2.00561C8.84569 1.59411 8.4413 1.3335 8.00024 1.3335C7.56001 1.3335 7.1559 1.59411 6.95903 2.00561L5.52129 5.02003L2.32599 5.51353C1.88884 5.58066 1.52703 5.90051 1.39092 6.3374C1.25482 6.77458 1.36684 7.25553 1.68273 7.57685L3.98973 9.93405Z"
        fill={`url(#${id})`}
      />
      <defs>
        <linearGradient id={id} x1="1.33398" y1="8.00016" x2="14.6673" y2="8.00016" gradientUnits="userSpaceOnUse">
          <stop stopColor={from} />
          <stop offset="1" stopColor={to} />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default IconStarGradient;
